import { CARD_SECTION_TYPE_ID, FEATURE_ENTRYPOINT_TYPE_ID } from '../constants';
import { ICardItemEntry } from './ICardItem';
import { IEntry } from './IEntry';
import { IBasePageSection } from './IPageSection';

// Contentful values, should not be changed
export enum CardSectionDisplay {
	Clickable = 'Clickable cards (with links)',
	NonClickable = 'Non-clickable cards (without links)',
	Feature = 'Feature entrypoint (with links)',
}

export interface ICardSection extends IBasePageSection {
	title?: string;
	subtitle?: string;
	items?: ICardItemEntry[];
	columns?: number;
	displayAs: CardSectionDisplay;
	clickable: boolean;
}

export interface ICardSectionEntry
	extends IEntry<
		ICardSection,
		typeof CARD_SECTION_TYPE_ID | typeof FEATURE_ENTRYPOINT_TYPE_ID
	> {}
